"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalitySearchExisting = exports.CausalityDialog = exports.CausalityContainer = exports.CausalityDisplay = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var lists_1 = require("../lib/lists");
var buttons_1 = require("../buttons");
var risks_1 = require("../../interfaces/risks");
var dialog_1 = require("../dialog");
var App_1 = require("../../App");
var react_tabs_1 = require("react-tabs");
var utils_1 = require("../../utils");
var lodash_1 = require("lodash");
var config_1 = require("../../config");
var api_1 = require("../../api");
var iterUtils_1 = require("../lib/iterUtils");
var contexts_1 = require("../../interfaces/contexts");
var multiSelect_1 = require("../lib/multiSelect");
var generic_1 = require("../generic");
var urls_1 = require("../../urls");
function CausalityDisplay(props) {
    var prefix = props.causality.is_cause ? gettext("Cause") : gettext("Effect");
    var text = props.causality.text;
    var cropped = false;
    if (props.maxTextLength && text.length > props.maxTextLength) {
        text = text.substring(0, props.maxTextLength) + "...";
        cropped = true;
    }
    return (React.createElement("span", { title: cropped ? props.causality.text : null },
        React.createElement("span", { className: "DomainItemBox DomainItemBox--causality" },
            prefix,
            " #",
            props.causality.number),
        " ",
        text));
}
exports.CausalityDisplay = CausalityDisplay;
var CausalityContainer = (function (_super) {
    __extends(CausalityContainer, _super);
    function CausalityContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            show_completed: false,
        };
        return _this;
    }
    CausalityContainer.prototype.getCheckboxId = function () {
        return this.props.isCause ? "show_completed_causes" : "show_completed_effects";
    };
    CausalityContainer.prototype.toggleDoneDiscarded = function (event) {
        this.setState(function (prevState) {
            return {
                show_completed: !prevState.show_completed
            };
        });
    };
    CausalityContainer.prototype.getStatuses = function () {
        return this.state.show_completed ?
            risks_1.CausalityStatusChoices.INCOMPLETE.concat(risks_1.CausalityStatusChoices.COMPLETE) :
            risks_1.CausalityStatusChoices.INCOMPLETE;
    };
    CausalityContainer.prototype.handleCreateNew = function (e) {
        (0, utils_1.preventDefault)(e);
        if (is_new_risk()) {
            notify_to_save_risk();
            return;
        }
        App_1.store.causalityDialog.openDialog(null, this.props.isCause);
    };
    CausalityContainer.prototype.handleDetach = function (c) {
        return App_1.store.riskPage.accordion.checkDetachCausality(c).then(function (page) { return App_1.store.riskPage.accordion.removeCausality(c); }, function (error) {
            var reason = JSON.parse(error.responseText);
            if (reason.confirm) {
                optionDialog(reason.confirm, [{
                        text: gettext("Retain confidentiality"),
                        "class": "btn btn-primary",
                        click: function () { return App_1.store.riskPage.accordion.removeCausality(c, true); }
                    }, {
                        text: gettext("Make public"),
                        "class": "btn btn-secondary",
                        click: function () { return App_1.store.riskPage.accordion.removeCausality(c, false); }
                    }], null, null, 500);
            }
            else {
                api_1.api.apiErrorHandler(error, null, null);
            }
        });
    };
    CausalityContainer.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var causalities = props.causalities.sort(function (a, b) { return a.number - b.number; });
        return (React.createElement("div", { className: "CausalityContainer" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col custom-control custom-switch mt-2" },
                    React.createElement("input", { type: "checkbox", className: "custom-control-input", onClick: this.toggleDoneDiscarded.bind(this), checked: this.state.show_completed, id: this.getCheckboxId.bind(this)() }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: this.getCheckboxId.bind(this)() }, gettext("Show closed/discarded"))),
                React.createElement("div", { className: "col ml-auto m-2 text-right" },
                    React.createElement(buttons_1.ActionButton, { noMargin: true, className: "btn-sm", onClick: this.handleCreateNew.bind(this) },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        " ",
                        props.isCause ? gettext("Add Cause") : gettext("Add Effect")))),
            React.createElement("div", { className: "Causality", id: props.isCause ? "causes_list" : "effects_list" },
                React.createElement(lists_1.ListObjects, { objects: causalities.filter(function (c) { return (0, iterUtils_1.contains)(_this.getStatuses(), c.status); }), editable: true, deletable: false, detachable: true, handleEdit: function (c) {
                        App_1.store.causalityDialog.openDialog(c);
                    }, handleDetach: this.handleDetach.bind(this), getKey: function (c) { return c.id; }, sortObjects: function (a, b) {
                        return a.status - b.status || a.number - b.number;
                    }, getListItemContent: function (c) { return React.createElement(CausalityDisplay, { causality: c }); }, groupByFunc: this.state.show_completed ?
                        function (c) { return c.status_display; } : null }))));
    };
    CausalityContainer = __decorate([
        mobx_react_1.observer
    ], CausalityContainer);
    return CausalityContainer;
}(React.Component));
exports.CausalityContainer = CausalityContainer;
var CausalityDialog = (function (_super) {
    __extends(CausalityDialog, _super);
    function CausalityDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.debouncedSearch = (0, lodash_1.debounce)(_this.loadCausalities, config_1.DEBOUNCE_DELAY);
        _this.state = _this.getStateFromProps(props);
        _this.loadCausalities({ searchTerm: "", statuses: risks_1.CausalityStatusChoices.INCOMPLETE });
        return _this;
    }
    CausalityDialog.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState(this.getStateFromProps(nextProps));
    };
    CausalityDialog.prototype.getStateFromProps = function (props) {
        return {
            text: props.causality ? props.causality.text : "",
            status: props.causality ?
                props.causality.status.toString() :
                risks_1.CausalityStatusChoices.OPEN.toString(),
        };
    };
    CausalityDialog.prototype.onTextChange = function (e) {
        this.setState({
            text: e.target.value
        });
    };
    CausalityDialog.prototype.onStatusChange = function (e) {
        this.setState({
            status: e.currentTarget.value,
        });
    };
    CausalityDialog.prototype.loadCausalities = function (options) {
        var context = App_1.store.context.get();
        if (context instanceof contexts_1.RiskContext) {
            App_1.store.causalityDialog.search(options.searchTerm, this.props.isCause, options.statuses);
        }
    };
    CausalityDialog.prototype.onSearchChange = function (options) {
        this.debouncedSearch(options);
    };
    CausalityDialog.prototype.submit = function () {
        var _this = this;
        var causality = {
            id: this.props.causality ? this.props.causality.id : null,
            text: this.state.text,
            is_cause: this.props.isCause,
            status: this.state.status,
        };
        App_1.store.causalityDialog.saveCausality(causality).then(function () {
            _this.props.afterSaveCallback && _this.props.afterSaveCallback();
        });
    };
    CausalityDialog.prototype.attachCausality = function (causality) {
        var _this = this;
        App_1.store.causalityDialog.attachCausality(causality).then(function () {
            _this.props.afterSaveCallback && _this.props.afterSaveCallback();
        });
    };
    CausalityDialog.prototype.render = function () {
        var props = this.props;
        var texts = {
            information: props.isCause ? gettext("Cause information") : gettext("Effect information"),
            existing: props.isCause ? gettext("Existing causes") : gettext("Existing effects"),
            defaultTitle: props.isCause ? gettext("Add cause") : gettext("Add effect"),
            type: props.isCause ? gettext("Cause") : gettext("Effect"),
            save: gettext("Save")
        };
        var title = props.causality ?
            "".concat(texts.type, " #").concat(props.causality.number, ": ").concat(props.causality.text) :
            texts.defaultTitle;
        var searchResults = props.isCause ? props.causeSearchResults : props.effectSearchResults;
        var risk_relations_header = props.isCause
            ? gettext("This cause affects the following risks")
            : gettext("This effect affects the following risks");
        return (React.createElement(dialog_1.Dialog, { isOpen: props.isOpen, forcedWidth: "480px", className: "CausalityDialog", onClose: function () { return App_1.store.causalityDialog.closeDialog(); }, contentLabel: title },
            React.createElement(react_tabs_1.Tabs, { selectedTabClassName: "active" },
                React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs" },
                    React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                        React.createElement("a", { className: "nav-link", href: "#0" }, texts.information)),
                    props.causality ?
                        React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                            React.createElement("a", { className: "nav-link", href: "#0" }, gettext("Relations")))
                        :
                            React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                                React.createElement("a", { className: "nav-link", href: "#0" }, texts.existing))),
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement("div", { className: "CausalityDialog__InputContainer" },
                        React.createElement("div", { className: "form-group row" },
                            React.createElement("div", { className: "col-4" },
                                React.createElement("label", { className: "col-form-label pl-3", htmlFor: "causality_status_id" }, gettext("Status"))),
                            React.createElement("div", { className: "col-8" },
                                React.createElement("select", { id: "causality_status_id", name: "status", className: "form-control", value: this.state.status, onChange: this.onStatusChange.bind(this) }, risks_1.CausalityStatusChoices.as_choices().map(function (choice) {
                                    return React.createElement("option", { key: choice.value, value: choice.value }, choice.display_name);
                                })))),
                        React.createElement("textarea", { className: "CausalityDialog__Input form-control", value: this.state.text, onChange: this.onTextChange.bind(this) })),
                    React.createElement("div", { className: "d-flex flex-column justify-content-end align-items-end" },
                        React.createElement(buttons_1.PrimaryButton, { onClick: this.submit.bind(this) }, texts.save))),
                props.causality ?
                    React.createElement(react_tabs_1.TabPanel, null,
                        React.createElement("div", { className: "Panel" },
                            React.createElement("h4", { className: "ReferenceList__Header" }, risk_relations_header),
                            React.createElement("ul", { className: "list-unstyled" },
                                React.createElement("li", null,
                                    React.createElement(App_1.LoadingSpinner, { loading: props.isLoadingRisks, size: 1 })),
                                props.affectedRisks.map(function (risk) {
                                    return React.createElement("li", { key: risk.id },
                                        React.createElement("a", { className: "RelationLink", href: risk.url },
                                            gettext("Risk"),
                                            " #",
                                            risk.number,
                                            " ",
                                            risk.title));
                                })),
                            React.createElement(generic_1.HTMXContentAnchor, null,
                                React.createElement("div", { "hx-get": (0, urls_1.resolve)(urls_1.Urls.causality_control_relations, props.causality.project, props.causality.id), "hx-trigger": "load", "hx-target": "this", "hx-swap": "innerHTML" }))))
                    :
                        React.createElement(react_tabs_1.TabPanel, null,
                            React.createElement("div", { className: "Panel" },
                                React.createElement(CausalitySearchExisting, { loading: props.isSearchingCausalities, searchResults: searchResults, onSearchChange: this.onSearchChange.bind(this), attachCausality: this.attachCausality.bind(this) }))))));
    };
    CausalityDialog = __decorate([
        mobx_react_1.observer
    ], CausalityDialog);
    return CausalityDialog;
}(React.Component));
exports.CausalityDialog = CausalityDialog;
var CausalitySearchExisting = (function (_super) {
    __extends(CausalitySearchExisting, _super);
    function CausalitySearchExisting(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchTerm: "",
            statuses: risks_1.CausalityStatusChoices.INCOMPLETE,
        };
        _this.props.onSearchChange(_this.state);
        return _this;
    }
    CausalitySearchExisting.prototype.handleSearchTerm = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            searchTerm: value
        });
    };
    CausalitySearchExisting.prototype.handleStatusChange = function (value, checked) {
        var status = parseInt(value);
        var statuses = this.state.statuses;
        if (checked) {
            statuses.push(status);
        }
        else {
            statuses.splice(this.state.statuses.indexOf(status), 1);
        }
        this.setState({
            statuses: statuses
        });
    };
    CausalitySearchExisting.prototype.onCheckAllStatuses = function () {
        this.setState({
            statuses: risks_1.CausalityStatusChoices.toList()
        });
    };
    CausalitySearchExisting.prototype.onUncheckAllStatuses = function () {
        this.setState({
            statuses: []
        });
    };
    CausalitySearchExisting.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var classes = props.loading ? "InputText--loading form-control" : "form-control";
        return (React.createElement("div", null,
            React.createElement("div", { className: "form-group" },
                React.createElement("label", null, gettext("Search")),
                React.createElement("input", { type: "text", onChange: this.handleSearchTerm.bind(this), className: classes })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", null,
                    gettext("Status"),
                    ":"),
                React.createElement(multiSelect_1.Multiselect, { name: "status", choices: risks_1.CausalityStatusChoices.as_choices(), value: this.state.statuses.map(function (s) { return s.toString(); }), onSingleChange: this.handleStatusChange.bind(this), onCheckAll: this.onCheckAllStatuses.bind(this), onUncheckAll: this.onUncheckAllStatuses.bind(this), selectedText: gettext('status(es) selected'), noneSelectedText: gettext("Select statuses"), classes: "MultiSelect__Button gm--fullwidth" })),
            React.createElement("div", { className: "form-group" },
                React.createElement(buttons_1.PrimaryButton, { onClick: function () { _this.props.onSearchChange(_this.state); }, noHMargin: true }, gettext("Search"))),
            React.createElement("div", { className: "CausalityDialog__SearchResultList" },
                React.createElement("ul", { className: "list-unstyled" }, props.searchResults.length ?
                    props.searchResults.map(function (causality) {
                        return (React.createElement("li", { key: causality.id, className: "CausalityContainer__SearchResult", onClick: function (e) { return props.attachCausality(causality); } },
                            React.createElement(CausalityDisplay, { causality: causality })));
                    })
                    :
                        React.createElement("span", null, pgettext("Search matches", "No matches"))))));
    };
    CausalitySearchExisting = __decorate([
        mobx_react_1.observer
    ], CausalitySearchExisting);
    return CausalitySearchExisting;
}(React.Component));
exports.CausalitySearchExisting = CausalitySearchExisting;
